var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{style:('min-height: 500px; background: ' + _vm.d_treeListData.style.backGround)},[(_vm.d_showTree)?[_c('document-tree-list',{attrs:{"p_treeListData":_vm.d_treeListData}})]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }